import { IJxtBookingInfoContainer } from './types';

const JxtBookingInfoContainer = ({ children }: IJxtBookingInfoContainer) => {
  return <div className="bg-neutral-10 p-3 rounded-lg">{children}</div>;
};

export default JxtBookingInfoContainer;
